export const normalizeSearch = (value: string) => value.normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/ß/g, "ss").trim();

const germanNames = new Intl.DisplayNames(["de"], {type: "region"});
const englishNames = new Intl.DisplayNames(["en"], {type: "region"});

export function matchesCountry(code: string, query: string, fallback = "") {
  const aliases = code.toUpperCase() === "GB" ? "UK United Kingdom Britain Grossbritannien England" :
    code.toUpperCase() === "US" ? "USA United States Amerika" : "";
  return normalizeSearch([code, fallback, germanNames.of(code.toUpperCase()),
    englishNames.of(code.toUpperCase()), aliases].join(" ")).includes(normalizeSearch(query));
}
